import { BorderType, PaddingType, AlignType } from 'common/types/styleTypes'
import {
  WebsiteButtonAndFormFieldTypes,
  WebsiteSettingsTypographyTypeEnum,
} from 'src/shared/types/website-settings-types'
import { useFontFamily } from '../use-typography/use-font-family'
import { useFontSize } from '../use-typography/use-font-size'
import { useLineHeight } from '../use-typography/use-line-height'
import { useTextAlign } from '../use-typography/use-text-align'
import { useLetterSpacing } from '../use-typography/use-letter-spacing'
import { useBorder } from '../use-border'
import { usePadding } from '../use-padding'
import { useFontStyle } from '../use-typography/use-font-style'
import { useFontWeight } from '../use-typography/use-font-weight'

export const useButton = ({
  border,
  mobileBorder,
  padding,
  mobilePadding,
  fontFamily,
  mobileFontFamily,
  fontSize,
  mobileFontSize,
  lineHeight,
  mobileLineHeight,
  textAlign,
  mobileTextAlign,
  letterSpacing,
  mobileLetterSpacing,
  fontStyle,
  mobileFontStyle,
  fontWeight,
  mobileFontWeight,
  buttonType = WebsiteSettingsTypographyTypeEnum.PrimaryButton,
}: {
  border?: Partial<BorderType>
  mobileBorder?: Partial<BorderType>
  padding?: PaddingType
  mobilePadding?: PaddingType
  buttonType?: WebsiteButtonAndFormFieldTypes
  fontSize?: number
  mobileFontSize?: number
  lineHeight?: number
  mobileLineHeight?: number
  textAlign?: AlignType
  mobileTextAlign?: AlignType
  letterSpacing?: number
  mobileLetterSpacing?: number
  fontFamily?: string
  mobileFontFamily?: string
  fontStyle?: string
  mobileFontStyle?: string
  fontWeight?: string
  mobileFontWeight?: string
}) => {
  const returnUsePadding = usePadding({
    padding,
    mobilePadding,
    type: buttonType,
  })

  const returnUseBorder = useBorder({
    border,
    mobileBorder,
    type: buttonType,
  })
  const returnUseFontFamily = useFontFamily({
    fontFamily,
    mobileFontFamily,
    typographyType: buttonType,
  })

  const returnUseFontStyle = useFontStyle({
    fontStyle,
    mobileFontStyle,
  })

  const returnUseFontWeight = useFontWeight({
    fontWeight,
    mobileFontWeight,
  })

  const returnUseFontSize = useFontSize({
    fontSize,
    mobileFontSize,
    typographyType: buttonType,
  })

  const returnUseLineHeight = useLineHeight({
    fontSize,
    mobileFontSize,
    lineHeight,
    mobileLineHeight,
    typographyType: buttonType,
  })

  const returnUseTextAlign = useTextAlign({
    textAlign,
    mobileTextAlign,
    typographyType: buttonType,
  })

  const returnUseLetterSpacing = useLetterSpacing({
    letterSpacing,
    mobileLetterSpacing,
    typographyType: buttonType,
  })

  return {
    ...returnUsePadding,
    ...returnUseBorder,
    ...returnUseFontSize,
    calculatedFontSize: {
      mobile: returnUseFontSize.calculatedFontSize.mobile as number,
      desktop: returnUseFontSize.calculatedFontSize.desktop as number,
    },
    ...returnUseLineHeight,
    ...returnUseTextAlign,
    ...returnUseLetterSpacing,
    ...returnUseFontFamily,
    ...returnUseFontWeight,
    ...returnUseFontStyle,
  }
}
